import { ApiColCollaboratorOut } from '../rest-api/rest-api';

export function isConsultant(checkedObj?: unknown): ApiColCollaboratorOut | null {
  if(
    !!checkedObj &&
    typeof checkedObj === 'object' &&
    'collaboratorId' in checkedObj &&
    typeof checkedObj.collaboratorId === 'number'
  ) {
    return checkedObj as ApiColCollaboratorOut;
  }
  return null;
}
